"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("../../../common/js/atoms/Icon"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const string_1 = require("../../../common/js/helper/string");
const Tooltip_1 = __importDefault(require("../../atoms/Tooltip"));
const TooltipPosition_1 = __importDefault(require("../../enums/TooltipPosition"));
const AssetsSoftwareLicenseUsageColumn = (props) => {
    const limit = 8;
    const shortenedText = (0, string_1.ellipsis)(props.license.usage, limit);
    const showTooltip = (props.license.usage?.length ?? 0) > limit;
    return (react_1.default.createElement("div", { "data-tag": "allowRowEvents", className: (0, classnames_1.default)('--white-space-normal', 'my-2', {
            'znd-table-tile__info znd-table-tile__info--dark': showTooltip,
        }) },
        react_1.default.createElement("span", { className: "znd-table-tile__name znd-table-tile__name--with-icon" }, shortenedText),
        showTooltip ? (react_1.default.createElement(Tooltip_1.default, { position: TooltipPosition_1.default.bottomCenter, label: props.license.usage ?? '', className: "align-self-center" },
            react_1.default.createElement("span", { className: "znd-table-tile__icon-info--dark" },
                react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.info, className: 'znd-table-tile__icon-info--dark-icon' })))) : null));
};
exports.default = AssetsSoftwareLicenseUsageColumn;
